export const searchEventNames = {
  'Search': true,
  'Results Actions': true,
  'Price Alert': true,
  'Filter Results': true,
  'Sort Results': true,
  'View Results': true,
  'Exchange View Results': true,
  'Tab Changed': true,
  'Picked Provider': true,
};

export const tripEventNames = {
  'Picked Departure': true,
  'Picked Return': true,
};

export const reservationEventNames = {
  'Seat Change': true,
  'Exchange Seat Change': true,
};

export const purchaseEventNames = {
  'Purchase Attempt': true,
  'Passengers Created': true,
  'Confirm Itinerary': true,
  'Purchase Redirect': true,
  'Exchange Attempt': true,
  'Exchange Passengers Created': true,
  'Exchange Confirm Itinerary': true,
};

export const userAccountEventNames = {
  'Sign Up': true,
  'Log In': true,
  'Log Out': true,
  'Interest in Account': true,
  'Profile Updated': true,
  'Card Saved': true,
  'Card Deleted': true,
};

export const otherEventNames = {
  'Interest in Home': true,
  'Interest in Redirect': true,
  'App Banner Printed': true,
  'App Banner Clicked': true,
  'Ad Printed': true,
  'Ad Clicked': true,
};

export default {
  ...searchEventNames,
  ...tripEventNames,
  ...reservationEventNames,
  ...purchaseEventNames,
  ...otherEventNames,
};



// WEBPACK FOOTER //
// ./constants/events.js